import styled from 'styled-components';
import { SearchBarProps } from './searchbar.types';

function getWidth(size: SearchBarProps['size']): string {
  switch (size) {
    case 'sm':
      return '124px';
    case 'md':
      return '174px';
    case 'lg':
      return '224px';
    case 'full':
      return '100%';
    default:
      return '174px';
  }
}

export const Container = styled.div<{ size: SearchBarProps['size'] }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: ${({ size }) => getWidth(size)};
`;

export const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${({ theme: { color } }) => color.ui3};
  ${({ theme: { font } }) => font.t4};
  background-color: transparent;
  height: 20px;
  width: 100%;
  padding-bottom: 4px;
  transition: 200ms all;

  &:focus {
    outline: none;
    background-color: ${({ theme: { color } }) => color.ui6};
  }
`;
